import { Injectable } from '@angular/core';
import { ApiService } from './api';

@Injectable()
export class AuthenticateService {
    constructor(private api: ApiService) { }

    authenticate(email: string, password: string) {
        return new Promise((resolve, reject) => {
            this.api
                .postWithoutAuth(this.api.endpoints.authenticate + '/token', {
                    EmailAddress: email,
                    Password: password,
                })
                .then(data => resolve(data), error => reject(error));
        });
    }

    logout() {
        return new Promise((resolve, reject) => {
            this.api
                .postWithAuth(this.api.endpoints.authenticate + '/revokeToken')
                .then(data => resolve(data), error => reject(error));
        });
    }

    refreshUserData() {
        return new Promise((resolve, reject) => {
            this.api.getWithAuth(this.api.endpoints.authenticate + '/refreshAuthResponse')
            .then(data => resolve(data), error => reject(error));
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/authenticateService.ts